import { useSelector, RootStateOrAny } from 'react-redux';
import { resolveTimeZone } from '@src/utils/userTimeZone';

const useUserTimeZone = (): string => {
	const timezone = useSelector((state: RootStateOrAny) => state.user?.profile?.timezone);
	return resolveTimeZone(timezone);
};

export default useUserTimeZone;
